import { render, staticRenderFns } from "./BasicDetails.vue?vue&type=template&id=8df2eefe&"
import script from "./BasicDetails.vue?vue&type=script&lang=js&"
export * from "./BasicDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports